import { stat } from "fs";

const currentYear = new Date().getFullYear();
export const LOGIN_PAGE = {
  en: {
    title: "Log In",
    emailPhone: "Email / Phone",
    password: "Password",
    rememberMe: "Remember Me",
    forgtPassword: "Forgot Password",
    submit: "Login",
    accountMessage: "Don’t have an account?",
    signInWithGoogle: "Sign In with Google",
    leftSideTitle: "Welcome Back!",
    leftSideSubTitle: "The voice of free speech.",
  },
  sp: {
    title: "Acceso",
    emailPhone: "Correo electrónico / Teléfono",
    password: "Contraseña",
    rememberMe: "Acuérdate de mí",
    forgtPassword: "Has olvidado tu contraseña",
    submit: "Acceso",
    accountMessage: "¿No tienes una cuenta?",
    signInWithGoogle: "Inicia sesión con Google",
    leftSideTitle: "¡Bienvenido de nuevo!",
    leftSideSubTitle: "La voz de la libertad de expresión.",
  },
};

export const SIGN_UP_PAGE = {
  en: {
    title: "Sign Up",
    name: "Name",
    email: "Email",
    phoneNo: "Phone No",
    birthday: "Birthday",
    alphaCode: "Alpha Code",
    brand: "Brand",
    selectSponsor: "Please select Sponsor",
    password: "Password",
    confirmPassword: "Confirm Password",
    button: "Sign Up",
    next: "Next",
    condition: "I agree all terms & conditions",
    accountMessage: "If you have an account?",
    signUpWithGoogle: "Sign Up with Google",
    signUpWithGoogleGetStarted: "Get Started",
  },
  sp: {
    title: "Inscribirse",
    name: "Nombre",
    email: "Correo electrónico",
    phoneNo: "Telefono no",
    birthday: "Cumpleaños",
    alphaCode: "Código Alfa",
    brand: "Marca",
    selectSponsor: "Por favor seleccione Patrocinador",
    password: "Contraseña",
    confirmPassword: "Confirmar Contraseña",
    button: "Inscribirse",
    next: "Próximo",
    condition: "Acepto todos los términos y condiciones",
    accountMessage: "Si tienes una cuenta?",
    signUpWithGoogle: "Regístrese con Google",
    signUpWithGoogleGetStarted: "Empezar",
  },
};

export const HEADER_MENU = {
  en: {
    home: "Home",
    qr_code: "QR Code",
    gallery: "Gallery",
    fan_corner: "Fan Corner",
    login: "Log In",
    logout: "Log Out",
    player: "Player",
    players: "Players",
    profile: "Profile",
    team: "Team",
    teams: "Teams",
    language_en: "English",
    language_sp: "Español",
  },
  sp: {
    home: "Hogar",
    qr_code: "Código QR",
    gallery: "Galería",
    fan_corner: "Rincón de los fanáticos",
    login: "Acceso",
    logout: "Cerrar Sesión",
    player: "Jugador",
    players: "Jugadores",
    profile: "Perfil",
    team: "Equipo",
    teams: "Equipos",
    language_en: "English",
    language_sp: "Español",
  },
};
export const SIDE_MENU_PROFILE = {
  en: {
    my_profile: "My Profile",
    change_password: "Change Password",
    my_cards: "My Cards",
    deal_list: "Deal List",
    card_list: "Card List",
    winner_history: "Winner History",
    deal_winner_history: "Deal Winner History",
    award_list: "Award List",
    store_address: "Store Address",
    dialog_title: "Select Option",
    dialog_sponsor: "Sponsor",
    dialog_deal: "Deal",
    dialog_message: "Please Select Deal",
    save: "Save",
    cancel: "Cancel",
    close: "Close",
  },
  sp: {
    my_profile: "Mi perfil",
    change_password: "Cambiar la contraseña",
    my_cards: "Mis Tarjetas",
    deal_list: "Lista de ofertas",
    card_list: "Lista de tarjetas",
    winner_history: "Historial de ganadores",
    deal_winner_history: "Historial de ganadores de acuerdos",
    award_list: "Lista de premios",
    store_address: "Dirección de la tienda",
    dialog_title: "Seleccionar opción",
    dialog_sponsor: "Patrocinador",
    dialog_deal: "Trato",
    dialog_message: "Seleccione oferta",
    save: "Ahorrar",
    cancel: "Cancelar",
    close: "Cerca",
  },
};
export const FOOTER_MENU = {
  en: {
    terms_of_use: "Terms Of Use",
    privacy_and_policy: "Privacy And Policy",
    about_us: "About US",
    all_rights_reserved: `2021-${currentYear} All Rights Reserved`,
    follow_us_on: "FOLLOW US ON",
  },
  sp: {
    terms_of_use: "Condiciones De Uso",
    privacy_and_policy: "Privacidad Y Política",
    about_us: "Sobre Nosotros",
    all_rights_reserved: `2021-${currentYear} Todos Los Derechos Reservados`,
    follow_us_on: "SIGA CON NOSOTROS",
  },
};

export const PROFILE_MYPROFILE = {
  en: {
    name: "Name",
    email: "Email",
    phone_no: "Phone No",
    birthdate: "Birthdate",
    upload_photo: "Upload Photo",
  },
  sp: {
    name: "Nombre",
    email: "Correo electrónico",
    phone_no: "Telefono no",
    birthdate: "Fecha de nacimiento",
    upload_photo: "Subir Foto",
  },
};

export const PROFILE_CHANGEPASSWORD = {
  en: {
    old_password: "Old Password",
    new_password: "New Password",
    confirm_new_password: "Confirm New Password",
  },
  sp: {
    old_password: "Contraseña anterior",
    new_password: "Nueva contraseña",
    confirm_new_password: "Confirmar nueva contraseña",
  },
};

export const PROFILE_MYCARDS = {
  en: {
    cards: "Cards",
    statistics: "Statistics",
  },
  sp: {
    cards: "Tarjetas",
    statistics: "Estadísticas",
  },
};
export const PROFILE_DEALLIST = {
  en: {
    deal_list: "Deal List",
    toggle_data: "Toggle Data",
    total_winner: "Total Winner",
    winner: "Selected Winner",
    redeem: "Prize Claimed",
    total_user: "Total Lcds",
  },
  sp: {
    deal_list: "Lista de ofertas",
    toggle_data: "Alternar datos",
    total_winner: "Ganadora Total",
    winner: "Ganador seleccionado",
    redeem: "Premio reclamado",
    total_user: "Pantallas LCD totales",
  },
};
export const PROFILE_WINNERHISTORY = {
  en: {
    winner_history: "Winner History",
    toggle_data: "Toggle Data",
    no: "No",
    user: "User",
    match: "Match",
    team_player: "Team/Player",
    offer: "Offer",
    offer_from: "Offer From",
    offer_to: "Offer To",
    redeemed: "Redeemed",
    redeemed_by: "Redeemed By",
    action: "Action",
    dialog_redeemed_offer: "Redeemed Offer",
    dialog_redeemed_offer_code: "Code",
    dialog_redeemed_offer_pin: "Pin",
    player_info_name: "Player Name",
    player_info_birthplace: "Birth Place",
    player_info_birthdate: "Birth Date",
    player_info_position: "Position",
    team_info_name: "Team Name",
    team_info_full_name: "Full Name",
    team_info_nationality: "Nationality",
    team_info_owner: "Owner",
    league_name: "League Name",
  },
  sp: {
    winner_history: "Historial de ganadores",
    toggle_data: "Alternar datos",
    no: "No",
    user: "Usuario",
    match: "Fósforo",
    team_player: "Equipo / Jugadora",
    offer: "Oferta",
    offer_from: "Oferta desde",
    offer_to: "Ofrecer",
    redeemed: "Redimida",
    redeemed_by: "Redimido Por",
    action: "Acción",
    dialog_redeemed_offer: "Oferta canjeada",
    dialog_redeemed_offer_code: "Código",
    dialog_redeemed_offer_pin: "Alfiler",
    player_info_name: "Nombre del jugador",
    player_info_birthplace: "Lugar de nacimiento",
    player_info_birthdate: "Fecha de nacimiento",
    player_info_position: "Posición",
    team_info_name: "Nombre del equipo",
    team_info_full_name: "Nombre completo",
    team_info_nationality: "Nacionalidad",
    team_info_owner: "Dueño",
    league_name: "Nombre de la liga",
  },
};

export const PROFILE_STORE_DEALLIST = {
  en: {
    card_list: "Card List",
    sell_lcd: "Sell Card",
    toggle_data: "Toggle Data",
    no: "No",
    user: "User",
    match: "Match",
    team_player: "Team/ Player",
    sell_by: "Sell By",
    winner: "Winner",
    redeem: "Redeem",
    dialog_scan_lcd: "Scan LCD",
    camera_permission: "Please allow camera permission.",
  },
  sp: {
    card_list: "Lista de tarjetas",
    sell_lcd: "Vender Tarjeta",
    toggle_data: "Alternar datos",
    no: "No",
    user: "Usuario",
    match: "Fósforo",
    team_player: "Equipo / Jugadora",
    sell_by: "Vender Por",
    winner: "Ganador",
    redeem: "Canjear",
    dialog_scan_lcd: "Escanear LCD",
    camera_permission: "Permita el permiso de la cámara.",
  },
};

export const PROFILE_AWARDLIST = {
  en: {
    award_list: "Award List",
    toggle_data: "Toggle Data",
    no: "NO",
    deal: "Deal",
    offer: "Offer",
    start_date: "Start Date",
    end_date: "End Date",
    offer_distribute: "Offer Distribute",
    total_winner: "Total Winner",
    action: "Action",
    dialog_add_title: "Add Award",
    dialog_edit_title: "Edit Award",
    dialog_match_name: "Match Name",
    dialog_team_player_name: "Team/Player Name",
    dialog_offer: "Offer",
    dialog_offer_start_date: "Offer Start Date",
    dialog_offer_end_date: "Offer End Date",
  },
  sp: {
    award_list: "Lista de premios",
    toggle_data: "Alternar datos",
    no: "NO",
    deal: "Trato",
    offer: "Oferta",
    start_date: "Fecha de inicio",
    end_date: "Fecha final",
    offer_distribute: "Oferta Distribuir",
    total_winner: "Ganador total",
    action: "Acción",
    dialog_add_title: "Agregar premio",
    dialog_edit_title: "Editar premio",
    dialog_match_name: "Nombre de coincidencia",
    dialog_team_player_name: "Nombre del equipo/jugador",
    dialog_offer: "Oferta",
    dialog_offer_start_date: "Fecha de inicio de la oferta",
    dialog_offer_end_date: "Fecha de finalización de la oferta",
  },
};

export const PROFILE_STOREADDRESS = {
  en: {
    address_list: "Address List",
    add_address: "Add Address",
    no: "No",
    user: "User",
    store: "Store",
    address: "Address",
    status: "Status",
    action: "Action",
    dialog_add_title: "Add Address",
    dialog_edit_title: "Edit Address",
    dialog_store_name: "Store Name",
    dialog_store_location: "Location",
    dialog_store_locality: "Apartment, Unit, Suite, or Floor",
    dialog_store_city: "City",
    dialog_store_state: "State",
    dialog_store_postal_code: "Postal Code",
    dialog_store_country: "Country",
  },
  sp: {
    address_list: "Lista de direcciones",
    add_address: "Añadir dirección",
    no: "No",
    user: "Usuario",
    store: "Almacenar",
    address: "DIRECCIÓN",
    status: "Estado",
    action: "Acción",
    dialog_add_title: "Añadir dirección",
    dialog_edit_title: "Editar dirección",
    dialog_store_name: "Nombre de la tienda",
    dialog_store_location: "Ubicación",
    dialog_store_locality: "Apartamento, Unidad, Suite o Piso",
    dialog_store_city: "Ciudad",
    dialog_store_state: "Estado",
    dialog_store_postal_code: "Código Postal",
    dialog_store_country: "Código Postal",
  },
};
export const ABOUT_US_SHORT_TITLE = {
  en: `ABOUT <span class="theme-white">US</span>`,
  sp: `SOBRE <span class="theme-white">NOSOTRAS</span>`,
};
export const ABOUT_US_SORT_DESCRIPTION = {
  en: `<p class="mb-2">Mission: We are the first advertising and marketing company that has designed an entertainment medium to unite companies, foundations and the amateur public by bringing new interactivity and marketing techniques to their clients.</p><p class="mb-2">View: To ensure that children, youth and adults can have at their disposal the technological advances that are necessary for their education and recreation. Bringing the most modern tools for its development.</p>`,
  sp: `<p class="mb-2">Misión: Somos la primera empresa de publicidad, mercadeo que ha diseño un medio de entretenimiento para unir a empresas, fundaciones y público aficionado al acercar nuevas técnicas de interactividad y comercialización a sus clientes.</p><p class="mb-2">Visión: Lograr que niños, jóvenes y adultos puedan tener a su disposición los adelantos tecnológicos que son necesarios para su educación y recreación. Acercando las más modernas herramientas para su desarrollo.</p>`,
};
export const ABOUT_US_FULL_TITLE = {
  en: "<h1>ABOUT US</h1>",
  sp: "<h1>SOBRE NOSOTRAS</h1>",
};
export const ABOUT_US_FULL_ONE = {
  en: "<h2>Mission</h2><p>We are the first advertising and marketing company that has designed an entertainment medium to unite companies, foundations and the amateur public by bringing new interactivity and marketing techniques to their clients.</p>",
  sp: "<h2>Misión</h2><p>Somos la primera empresa de publicidad, mercadeo que ha diseño un medio de entretenimiento para unir a empresas, fundaciones y público aficionado al acercar nuevas técnicas de interactividad y comercialización a sus clientes.</p>",
};
export const ABOUT_US_FULL_TWO = {
  en: `<h2>View</h2><p>To ensure that children, youth and adults can have at their disposal the technological advances that are necessary for their education and recreation. Bringing the most modern tools for its development.</p>`,
  sp: "<h2>Visión</h2><p>Lograr que niños, jóvenes y adultos puedan tener a su disposición los adelantos tecnológicos que son necesarios para su educación y recreación. Acercando las más modernas herramientas para su desarrollo.</p>",
};
export const ABOUT_US_FULL_THREE = {
  en: `<h2>Introduction</h2>
    <p>Advertising agencies from their inception did not have directors or account executives, in fact the advertising career did not require experience. The first agencies were simple merchants of advertising space buying pages in newspapers and POP products (Pens, Caps, Etc.).</p>
    <p>In recent years, the advertising business has become very dynamic, where brands compete to see their image reflected within that small medium they can reach.</p>
    <p>Given that the mainstream media is saturated, we must find a way to get those sponsorships within each of the corporations through new internal ideas and identify a competitive advantage.</p>
    <p>Traditional media are expensive, the trend is clear and new ways of communication must be sought to achieve their mission.</p>
    <p>We must start investing in new digital media where a client and a sponsor make a profit. Both parties must win.</p>
    <p>LCD Laser Card Disc has initiated the transition into this new era of advertising, driving the development of new alternative means of economic growth to sports corporations and sports sponsors.</p>
    <p>LCD is a link for the big brands with their products towards fans or sports fans, they will not only be able to have the image of their team or player inside an LCD but they will also be able to have the identification of the sponsor with SLICE (name of the cuts commercial within the LCD) and may obtain from these: Prizes, Discounts or Gifts.</p>
    <p>LCD is: Advertising within advertising.</p>
    <h3 class="icon-circle-dot"> Value Proposal:</h3>
    <p>LCD Cards are a product that informs, educates, entertains and is collectible. These characteristics are unique, they are their own, they are new. The solution to eliminate indiscriminate felling for the production of: newspapers, magazines, posters, albums and an endless number of products reaches the world market, other than its raw material is Trees.</p>
  <p>LCDs will replace these products, they are more compact, everyone will be able to read it, only here in Venezuela, being this a medium country with internet access, there are more than 5,000,000 computers with recognized connection, which gives a step to the viability of the product Although an INTERNET connection is not necessary to use it, but a computer where this percentage would be multiplied by 2, giving a total of 10,000,000 Computers. The market would be born and grow with this green consciousness.</p>`,
  sp: `<h2>Introducción</h2>
    <p>Las agencias de publicidad desde sus inicios no tenían directores ni ejecutivos de cuenta, de hecho la carrera publicitaria no requería experiencia. Las primeras agencias eran simples comerciantes de espacios publicitarios comprando páginas en periódicos y productos POP (bolígrafos, gorras, etc.).</p>
    <p>En los últimos años, el negocio de la publicidad se ha vuelto muy dinámico, donde las marcas compiten por ver su imagen reflejada dentro de ese pequeño medio al que pueden llegar.</p>
    <p>Dado que los principales medios de comunicación están saturados, debemos encontrar la manera de conseguir esos patrocinios dentro de cada una de las corporaciones a través de nuevas ideas internas e identificar una ventaja competitiva.</p>
    <p>Los medios tradicionales son caros, la tendencia es clara y se deben buscar nuevas formas de comunicación para lograr su cometido.</p>
    <p>Debemos comenzar a invertir en nuevos medios digitales donde un cliente y un patrocinador obtengan ganancias. Ambas partes deben ganar.</p>
    <p>LCD Laser Card Disc ha iniciado la transición hacia esta nueva era de la publicidad, impulsando el desarrollo de nuevos medios alternativos de crecimiento económico para las corporaciones deportivas y los patrocinadores deportivos.</p>
    <p>LCD es un enlace de las grandes marcas con sus productos hacia los aficionados o aficionados al deporte, no solo podrán tener la imagen de su equipo o jugador dentro de un LCD sino que también podrán tener la identificación del patrocinar con SLICE (nombre de los cortes comerciales dentro del LCD) y podrá obtener de estos: Premios, Descuentos o Regalos.</p>
    <p>LCD es: Publicidad dentro de la publicidad.</p>
    <h3 class="icon-circle-dot"> Propuesta de valor:</h3>
    <p>Las Tarjetas LCD son un producto que informa, educa, entretiene y es coleccionable. Estas características son únicas, son propias, son nuevas. La solución para eliminar la tala indiscriminada para la elaboración de: periódicos, revistas, afiches, álbumes y un sinfín de productos llega al mercado mundial, además de que su materia prima son los árboles.</p>
  <p>Los LCD reemplazarán estos productos, son más compactos, todos podrán leerlo, solo aquí en Venezuela, siendo este un país mediano con acceso a internet, hay más de 5.000.000 de computadoras con conexión reconocida, lo que da un paso a la viabilidad del producto Aunque no es necesaria una conexión a INTERNET para utilizarlo, sino un ordenador donde este porcentaje se multiplicaría por 2, dando un total de 10.000.000 Ordenadores. El mercado nacería y crecería con esta conciencia verde.</p>`,
};
export const ABOUT_US_FULL_FOUR = {
  en: `<h2>TARGET MARKET</h2><h3 class="icon-circle-dot"> The business opportunity that the product identifies:</h3>
    <p>LCD (Acronym that in English means: LASER CARD DISC), Digital Electronic Playing Cards, as it will be announced in Spanish.</p>
  <p>The electronic cards that will be issued for the promotion and information of: People, Groups, Collectives, Companies and / or Corporations (Sports), may have in a single Medium all the details of images, statistical data, videos and interviews of their choice. Where the final buyer of the product can enjoy a new advance in interactive electronic communication.</p>
  <p>With these main business details, the new era of the collection of images, data or videos of a player or teams opens in Venezuela and the world, which will also provide all those who acquire the product or collectors the opportunity to obtain a award for your devotion by participating in the countless ways of promoting advertisers who will have access to this new electronic marketing and advertising system.</p>
  <p>LCD is an advertising campaign as it helps you get advertisers to sponsor your franchise and accumulate profitability or donations through your customers. SEMI - LCD is a program that is used as an advertising campaign which was designed for the holder of the license to use the SEMI Electronic Internet Marketing System program to use the program for a specified time, as it will help them get advertisers to sponsoring your franchise and accumulate profitability or donations through your clients.</p>
  <p>LCD (Acronym that in English means): LASER CARD DISC-Digital Electronic Card), or Digital Electronic Card as it will be announced in Spanish, is a product that identifies the system for the promotion of: images, data or videos of a player, team and being able to extend to any type of hobby since it can have images and sounds. It is the new era of the collection of electronic cards.</p>
  <p>SEMI - LCD is aimed at: Sports Franchises, Business Groups, People (Artists) or Government Entities worldwide that by acquiring the program (SEMI) Electronic Internet Marketing System will generate profits when applying the product which is a dual service that applies as an advertising campaign.</p>
  <h3 class="icon-circle-dot"> Products and / or services offered by the project:</h3>
  <p>The main idea of ​​SEMI - LCD will not be the elaboration, manufacture or digitization of the multiple and different LCDs that arise when a third party signs a contract to use the Product and / or Service Use License.</p>
  <p>It translates to the moment that a consumer (Amateur) acquires (buys) his LCD and places it on his computer to navigate within the different sections of the internal program of the Digital Electronic Card, such as: photographs, statistical data, videos of plays, interviews, institutional messages, etc., is that you will also be able to observe the cuts of advertisements or publications of the thousands of advertisers and / or sponsors of a private system, which will have a unique marketing link to our website: www.lcdprize.com to qualify for offers that will be defined by the latter.</p>
  <p>In other words, the new era of Digital Electronic Playing Cards would begin in Mini-CD / Pendrive-Card or any other electromagnetic device or Qr Code for data storage.</p>`,
  sp: `<h2>MERCADO OBJETIVO</h2><h3 class="icon-circle-dot"> La oportunidad de negocio que identifica el producto:</h3>
    <p>LCD (Acrónimo que en inglés significa: LASER CARD DISC), Naipes Electrónicos Digitales, como se anunciará en español.</p>
  <p>Las tarjetas electrónicas que serán emitidas para la promoción e información de: Personas, Grupos, Colectivos, Empresas y/o Corporaciones (Deportes), podrán tener en un solo Medio todos los detalles de imágenes, datos estadísticos, videos y entrevistas de su elección. Donde el comprador final del producto podrá disfrutar de un nuevo avance en comunicación electrónica interactiva.</p>
  <p>Con estos principales detalles comerciales, se abre en Venezuela y el mundo la nueva era de la recopilación de imágenes, datos o videos de un jugador o equipos, que también brindará a todos aquellos que adquieran el producto o coleccionistas la oportunidad de obtener una premio por su dedicación al participar en las innumerables formas de promoción de los anunciantes que tendrán acceso a este nuevo sistema de publicidad y marketing electrónico.</p>
  <p>LCD es una campaña publicitaria, ya que le ayuda a lograr que los anunciantes patrocinen su franquicia y acumulen ganancias o donaciones a través de sus clientes. SEMI - LCD es un programa que se utiliza como una campaña publicitaria que fue diseñado para que el titular de la licencia de uso del programa SEMI Electronic Internet Marketing System utilice el programa durante un tiempo específico, ya que le ayudará a lograr que los anunciantes patrocinen su franquicia y acumula rentabilidad o donaciones a través de tus clientes.</p>
  <p>LCD (Acrónimo que en inglés significa: LASER CARD DISC-Tarjeta Electrónica Digital), o Tarjeta Electrónica Digital como se anunciará en español, es un producto que identifica al sistema para la promoción de: imágenes, datos o videos de un jugador, equipo y pudiendo extenderse a cualquier tipo de afición ya que puede disponer de imágenes y sonidos. Es la nueva era del cobro de tarjetas electrónicas.</p>
  <p>SEMI - LCD está dirigido a: Franquicias Deportivas, Grupos Empresariales, Personas (Artistas) o Entidades Gubernamentales a nivel mundial que al adquirir el programa (SEMI) Electronic Internet Marketing System generarán ganancias al aplicar el producto el cual es un servicio dual que aplica como campaña publicitaria.</p>
  <h3 class="icon-circle-dot"> Productos y/o servicios que ofrece el proyecto:</h3>
  <p>La idea principal de SEMI - LCD no será la elaboración, fabricación o digitalización de los múltiples y diferentes LCDs que surgen cuando un tercero firma un contrato de uso de la Licencia de Uso del Producto y/o Servicio.</p>
  <p>Se traduce al momento que un consumidor (Amateur) adquiere (compra) su LCD y lo coloca en su computadora para navegar dentro de las diferentes secciones del programa interno de la Tarjeta Electrónica Digital, tales como: fotografías, datos estadísticos, videos de obras de teatro, entrevistas, mensajes institucionales, etc., es que también podrá observar los cortes de anuncios o publicaciones de los miles de anunciantes y/o patrocinadores de un sistema privado, los cuales tendrán un enlace comercial único a nuestro sitio web: www.lcdprize.com para calificar para las ofertas que serán definidas por este último.</p>
  <p>En otras palabras, la nueva era de los Naipes Electrónicos Digitales comenzaría en Mini-CD/Pendrive-Card o cualquier otro dispositivo electromagnético o Qr Code para almacenamiento de datos.</p>`,
};
export const ABOUT_US_FULL_FIVE = {
  en: `<h2>POTENTIAL MARKET</h2>
    <h3 class="icon-circle-dot"> Product and Service offered by LCD:</h3>
    <p>The main product offered to sports companies, associations or corporations is the ability to place on an electronic storage device: images, sounds, interviews, statistical data, videos of plays or historical moments that must be reproduced and enhanced for the enjoy a hobby you will never forget.</p>
    <p>Through LCD, advertisers will obtain a product that they will seek to integrate to their brands where they will rely on the Digital Electronic Card, to achieve that statistical data, images, videos, interviews that you as a franchisee, Corporation, Association, Business Group have and you want to expose the public. Making these your allies for development and / or financing.</p>
    <p>For the fan and collector, this product will be a new way to achieve their greatest desire, which leads to that devotion and admiration of their franchise and player. In addition to all this will be the possibility of obtaining some type of award from advertisers and / or sponsors through what we know here in Venezuela as: (Barajita Awarded).</p>
    <p>The Prize Cards will be controlled electronically and Digitally. All LCDs will have an internal identification code that can only be read by our SEMI program, which will be on the internet through: www.lcdprize.com</p>
    <p>The program will control the originality of the product, that is, there cannot be two (02) LCDs with the same code. This is achieved when an amateur buys an LCD, he must activate it through the Internet with a direct link to our page at that time the fan is identified as the owner of an original LCD. With this step the product is secured with a unique electronic originality system. A CEA (Electronic Certificate of Authenticity) will be sent to the owner of the LCD, your card cannot be cloned: <b>THERE CAN ONLY BE ONE</b></p>
    <p><b>The service that will be offered to Advertisers and Sponsors is:</b> LPC (Private Marketing Link), the program identifies the Deck, announcing that it is an original, then the fan presses a button or a link within the Deck that takes them directly to our program that will tell you whether or not I win a prize.</p>
    <p>When a fan buys and then introduces the LCD into his computer to navigate within the different sections of the internal program of the Digital Electronic Card, such as: photographs, statistical data, videos of plays, interviews, institutional messages, he will also be able to observe the cuts of advertisements or publications of the thousands of advertisers and / or sponsors of a private system, which will have a unique marketing link to our WEB page: www.lcdprize.com.ve, to opt for offers that will be defined by the latter.</p>
    <p>In other words, the new era of Digital Electronic Playing Cards will begin.</p>`,
  sp: `<h2>MERCADO POTENCIAL</h2>
    <h3 class="icon-circle-dot"> Producto y Servicio ofrecido por LCD:</h3>
    <p>El principal producto que se ofrece a las empresas, asociaciones o corporaciones deportivas es la posibilidad de colocar en un dispositivo de almacenamiento electrónico: imágenes, sonidos, entrevistas, datos estadísticos, videos de jugadas o momentos históricos que deben ser reproducidos y mejorados para el disfrute de una pasatiempo que nunca olvidarás.</p>
    <p>A través de LCD, los anunciantes obtendrán un producto que buscarán integrar a sus marcas donde se apoyarán en la Tarjeta Electrónica Digital, para lograr datos estadísticos, imágenes, videos, entrevistas que usted como franquiciado, Corporación, Asociación , Grupo Empresarial tiene y quiere exponer al público. Haciendo de estos tus aliados para el desarrollo y/o financiamiento.</p>
    <p>Para el aficionado y coleccionista, este producto será una nueva forma de alcanzar su mayor anhelo, que lleva a esa devoción y admiración por su franquicia y jugador. Sumado a todo esto estará la posibilidad de obtener algún tipo de premio por parte de anunciantes y/o patrocinadores a través de lo que aquí en Venezuela conocemos como: (Premio Barajita).</p>
    <p>Las Tarjetas de Premio serán controladas electrónica y Digitalmente. Todos los LCD tendrán un código de identificación interno que solo podrá ser leído por nuestro programa SEMI, el cual estará en internet a través de: www.lcdprize.com</p>
    <p>El programa controlará la originalidad del producto, es decir, no puede haber dos (02) LCDs con el mismo código. Esto se logra cuando un aficionado compra un LCD, debe activarlo a través de Internet con un enlace directo a nuestra página en ese momento se identifica al aficionado como propietario de un LCD original. Con este paso se asegura el producto con un sistema único de originalidad electrónica. Se enviará un CEA (Certificado electrónico de autenticidad) al propietario de la pantalla LCD, su tarjeta no se puede clonar: <b>SOLO PUEDE HABER UNO</b></p>
    <p><b>El servicio que se ofrecerá a los Anunciantes y Patrocinadores es:</b> LPC (Private Marketing Link), el programa identifica la Baraja, anunciando que es original, luego el aficionado presiona un botón o un enlace dentro del Deck que los lleva directamente a nuestro programa que le dirá si gano o no un premio.</p>
    <p>Cuando un hincha compra y luego introduce el LCD en su computadora para navegar dentro de las diferentes secciones del programa interno de la Tarjeta Electrónica Digital, tales como: fotografías, datos estadísticos, videos de jugadas, entrevistas, mensajes institucionales, también podrá observar los cortes de anuncios o publicaciones de los miles de anunciantes y/o patrocinadores de un sistema privado, los cuales tendrán un enlace comercial único a nuestra página WEB: www.lcdprize.com.ve, para optar a ofertas que será definido por este último.</p>
    <p>En otras palabras, comenzará la nueva era de los naipes electrónicos digitales.</p>`,
};
export const ABOUT_US_FULL_SIX = {
  en: `<h2>COMPETITION</h2>
    <h3 class="icon-circle-dot"> Target audience, their characteristics and needs:</h3>
    <p>The public that is framed within this new marketing and advertising initiative will be open to a wide range of possibilities that will be initially promoted by Sports Associations, Teams, Companies or Corporations that, for the preparation of LCDs, will be able to make all the Cards that wish. Where they will transform a need into something tangible for the amateur and collector public.</p>
    <p>An important characteristic is for advertisers is that they will work in this new industry of Digital Electronic Advertising to be able to attract clients with new messages directed to a very wide audience that likes to go to Sports events and is simply a frequent consumer worldwide.</p>
    <p>The fan or collector of a team and / or franchise will acquire a product that meets their needs because not only will they obtain the images and / or videos of their star players, but they will also have the option of an award-winning deck.</p>
    <p>Statistics show us that more fans are added as long as there are elements associated with them and that a product should be mostly consumed if it has an additional appeal.</p>
    <h3 class="icon-circle-dot"> Market size, growth projection and expectations of participation in it:</h3>
    <p>The size of the market for this new promotional product through LCDs is potentially wide in that we must include the owner of the License for a determined period of time (Sports Teams, Artists, Companies and Commerce Worldwide) who, through the search for Sponsors for the development of LCDs will be able to add affiliates to their particular network where the Advertisers will also work to place their direct line of promotion through the SEMI program and finally the fan who will buy the product for three reasons:</p>
    <p><b>1)</b> Have pictures, statistical data, exclusive interviews of your sports idols</p>
    <p><b>2)</b> You can get through the advertisers that make life within the LCD, offers or promotions of their products.</p>
    <p><b>3)</b> In order to attract even more followers to this new promotion modality, the Owners of the SEMI program and advertisers will be able to offer Award-Winning Cards, which just by opening the LCD on your computer will indicate that you have been the winner of a fantastic prize special. (What is known in Venezuela as the Prize-winning Barajita)</p>
    <p>The market growth alternatives for this product are endless, it can be extended for years, since a team or owner of the SEMI-LCD program will offer the market a Card with specific data for that edition and advertisers will promote their own products for that issue. of Digital Electronic Cards and they may change in weeks, months and even years and advertisers as well.</p>
    <p>This License can be sold worldwide, since in all the countries of the world there are Sports and Artistic idols.</p>
    <p>In the National or International market, there is nothing similar, we are making history with the beginning of the new Digital era of Cards for promotions, we will become King Midas, of this extraordinary opportunity for promotion and Business.</p>`,
  sp: `<h2>COMPETICIÓN</h2>
    <h3 class="icon-circle-dot"> Público objetivo, sus características y necesidades:</h3>
    <p>El público que se enmarca dentro de esta nueva iniciativa de marketing y publicidad estará abierto a un amplio abanico de posibilidades que inicialmente serán promovidas por Asociaciones Deportivas, Equipos, Empresas o Corporaciones que, para la elaboración de LCDs, podrán Haz todas las Tarjetas que desees. Donde transformarán una necesidad en algo tangible para el público amateur y coleccionista.</p>
    <p>Una característica importante para los anunciantes es que trabajarán en esta nueva industria de la Publicidad Electrónica Digital para poder captar clientes con nuevos mensajes dirigidos a un público muy amplio que le gusta ir a eventos deportivos y es simplemente un consumidor frecuente en todo el mundo.</p>
    <p>El hincha o coleccionista de un equipo y/o franquicia adquirirá un producto que se ajuste a sus necesidades porque no solo obtendrá las imágenes y/o videos de sus jugadores estrella, sino que también tendrá la opción de un premio- mazo ganador.</p>
    <p>Las estadísticas nos muestran que se agregan más fanáticos siempre que haya elementos asociados con ellos y que un producto debe consumirse principalmente si tiene un atractivo adicional.</p>
    <h3 class="icon-circle-dot"> Tamaño del mercado, proyección de crecimiento y expectativas de participación en el mismo:</h3>
    <p>El tamaño del mercado para este nuevo producto promocional a través de LCDs es potencialmente amplio en el sentido de que debemos incluir al titular de la Licencia por un período de tiempo determinado (Equipos Deportivos, Artistas, Empresas y Comercio Mundial) quien a través de la búsqueda para los Patrocinadores para el desarrollo de LCDs podrán agregar afiliados a su red particular donde también trabajarán los Anunciantes para colocar su línea directa de promoción a través del programa SEMI y finalmente el fan que comprará el producto por tres razones:</p>
    <p><b>1)</b> Tener fotos, datos estadísticos, entrevistas exclusivas de tus ídolos deportivos</p>
    <p><b>2)</b> Podrás conseguir a través de los anunciantes que hacen vida dentro del LCD, ofertas o promociones de sus productos.</p>
    <p><b>3)</b> Con el fin de atraer aún más seguidores a esta nueva modalidad de promoción, los Titulares del programa SEMI y los anunciantes podrán ofrecer Tarjetas Premiadas, que con solo abrir el LCD en tu ordenador te indicará que has sido el ganador de un fantástico premio especial. (Lo que se conoce en Venezuela como la Barajita Premiada)</p>
    <p>Las alternativas de crecimiento del mercado para este producto son infinitas, se puede extender por años, ya que un equipo o propietario del programa SEMI-LCD ofrecerá al mercado una Tarjeta con datos específicos para esa edición y los anunciantes promocionarán sus propios productos para ese tema. de Tarjetas Electrónicas Digitales y pueden cambiar en semanas, meses e incluso años y anunciantes también.</p>
    <p>Esta Licencia se puede vender en todo el mundo, ya que en todos los países del mundo existen ídolos Deportivos y Artísticos.</p>
    <p>En el mercado Nacional o Internacional, no hay nada parecido, estamos haciendo historia con el inicio de la nueva era Digital de las Tarjetas para promociones, nos convertiremos en el Rey Midas, de esta extraordinaria oportunidad de promoción y Negocio.</p>`,
};
export const ABOUT_US_FULL = {
  en: [
    {
      field_name: "about_us",
      name: `Mission: We are the first advertising and marketing company that has designed an entertainment medium to unite companies, foundations and the amateur public by bringing new interactivity and marketing techniques to their clients. View: To ensure that children, youth and adults can have at their disposal the technological advances that are necessary for their education and recreation. Bringing the most modern tools for its development.
  
          Introduction
  
          Advertising agencies from their inception did not have directors or account executives, in fact the advertising career did not require experience. The first agencies were simple merchants of advertising space buying pages in newspapers and POP products (Pens, Caps, Etc.).
  
          In recent years, the advertising business has become very dynamic, where brands compete to see their image reflected within that small medium they can reach.
  
          Given that the mainstream media is saturated, we must find a way to get those sponsorships within each of the corporations through new internal ideas and identify a competitive advantage.
  
          Traditional media are expensive, the trend is clear and new ways of communication must be sought to achieve their mission.
  
          We must start investing in new digital media where a client and a sponsor make a profit. Both parties must win.
  
          LCD Laser Card Disc has initiated the transition into this new era of advertising, driving the development of new alternative means of economic growth to sports corporations and sports sponsors.
  
          LCD is a link for the big brands with their products towards fans or sports fans, they will not only be able to have the image of their team or player inside an LCD but they will also be able to have the identification of the sponsor with SLICE (name of the cuts commercial within the LCD) and may obtain from these: Prizes, Discounts or Gifts.
  
          LCD is: Advertising within advertising.
  
          • Value Proposal.
  
          LCD Cards are a product that informs, educates, entertains and is collectible. These characteristics are unique, they are their own, they are new. The solution to eliminate indiscriminate felling for the production of: newspapers, magazines, posters, albums and an endless number of products reaches the world market, other than its raw material is Trees.
  
          LCDs will replace these products, they are more compact, everyone will be able to read it, only here in Venezuela, being this a medium country with internet access, there are more than 5,000,000 computers with recognized connection, which gives a step to the viability of the product Although an INTERNET connection is not necessary to use it, but a computer where this percentage would be multiplied by 2, giving a total of 10,000,000 Computers. The market would be born and grow with this green consciousness
  
          TARGET MARKET
  
          • The business opportunity that the product identifies:
  
          LCD (Acronym that in English means: LASER CARD DISC), Digital Electronic Playing Cards, as it will be announced in Spanish.
  
          The electronic cards that will be issued for the promotion and information of: People, Groups, Collectives, Companies and / or Corporations (Sports), may have in a single Medium all the details of images, statistical data, videos and interviews of their choice. Where the final buyer of the product can enjoy a new advance in interactive electronic communication.
  
          With these main business details, the new era of the collection of images, data or videos of a player or teams opens in Venezuela and the world, which will also provide all those who acquire the product or collectors the opportunity to obtain a award for your devotion by participating in the countless ways of promoting advertisers who will have access to this new electronic marketing and advertising system.
  
          LCD is an advertising campaign as it helps you get advertisers to sponsor your franchise and accumulate profitability or donations through your customers. SEMI - LCD is a program that is used as an advertising campaign which was designed for the holder of the license to use the SEMI Electronic Internet Marketing System program to use the program for a specified time, as it will help them get advertisers to sponsoring your franchise and accumulate profitability or donations through your clients.
  
          LCD (Acronym that in English means): LASER CARD DISC-Digital Electronic Card), or Digital Electronic Card as it will be announced in Spanish, is a product that identifies the system for the promotion of: images, data or videos of a player, team and being able to extend to any type of hobby since it can have images and sounds. It is the new era of the collection of electronic cards.
  
          SEMI - LCD is aimed at: Sports Franchises, Business Groups, People (Artists) or Government Entities worldwide that by acquiring the program (SEMI) Electronic Internet Marketing System will generate profits when applying the product which is a dual service that applies as an advertising campaign.
  
          • Products and / or services offered by the project.
  
          The main idea of ​​SEMI - LCD will not be the elaboration, manufacture or digitization of the multiple and different LCDs that arise when a third party signs a contract to use the Product and / or Service Use License.
  
          It translates to the moment that a consumer (Amateur) acquires (buys) his LCD and places it on his computer to navigate within the different sections of the internal program of the Digital Electronic Card, such as: photographs, statistical data, videos of plays, interviews, institutional messages, etc., is that you will also be able to observe the cuts of advertisements or publications of the thousands of advertisers and / or sponsors of a private system, which will have a unique marketing link to our website: www.lcdprize.com to qualify for offers that will be defined by the latter.
  
          In other words, the new era of Digital Electronic Playing Cards would begin in Mini-CD / Pendrive-Card or any other electromagnetic device or Qr Code for data storage.
  
          POTENTIAL MARKET
  
          • Product and Service offered by LCD.
  
          The main product offered to sports companies, associations or corporations is the ability to place on an electronic storage device: images, sounds, interviews, statistical data, videos of plays or historical moments that must be reproduced and enhanced for the enjoy a hobby you will never forget.
  
          Through LCD, advertisers will obtain a product that they will seek to integrate to their brands where they will rely on the Digital Electronic Card, to achieve that statistical data, images, videos, interviews that you as a franchisee, Corporation, Association, Business Group have and you want to expose the public. Making these your allies for development and / or financing.
  
          For the fan and collector, this product will be a new way to achieve their greatest desire, which leads to that devotion and admiration of their franchise and player. In addition to all this will be the possibility of obtaining some type of award from advertisers and / or sponsors through what we know here in Venezuela as: (Barajita Awarded).
  
          The Prize Cards will be controlled electronically and Digitally. All LCDs will have an internal identification code that can only be read by our SEMI program, which will be on the internet through: www.lcdprize.com
  
          The program will control the originality of the product, that is, there cannot be two (02) LCDs with the same code. This is achieved when an amateur buys an LCD, he must activate it through the Internet with a direct link to our page at that time the fan is identified as the owner of an original LCD. With this step the product is secured with a unique electronic originality system. A CEA (Electronic Certificate of Authenticity) will be sent to the owner of the LCD, your card cannot be cloned: THERE CAN ONLY BE ONE
  
          The service that will be offered to Advertisers and Sponsors is: LPC (Private Marketing Link), the program identifies the Deck, announcing that it is an original, then the fan presses a button or a link within the Deck that takes them directly to our program that will tell you whether or not I win a prize.
  
          When a fan buys and then introduces the LCD into his computer to navigate within the different sections of the internal program of the Digital Electronic Card, such as: photographs, statistical data, videos of plays, interviews, institutional messages, he will also be able to observe the cuts of advertisements or publications of the thousands of advertisers and / or sponsors of a private system, which will have a unique marketing link to our WEB page: www.lcdprize.com.ve, to opt for offers that will be defined by the latter.
  
          In other words, the new era of Digital Electronic Playing Cards will begin.
  
          COMPETITION
  
          • Target audience, their characteristics and needs
  
          The public that is framed within this new marketing and advertising initiative will be open to a wide range of possibilities that will be initially promoted by Sports Associations, Teams, Companies or Corporations that, for the preparation of LCDs, will be able to make all the Cards that wish. Where they will transform a need into something tangible for the amateur and collector public.
  
          An important characteristic is for advertisers is that they will work in this new industry of Digital Electronic Advertising to be able to attract clients with new messages directed to a very wide audience that likes to go to Sports events and is simply a frequent consumer worldwide.
  
          The fan or collector of a team and / or franchise will acquire a product that meets their needs because not only will they obtain the images and / or videos of their star players, but they will also have the option of an award-winning deck.
  
          Statistics show us that more fans are added as long as there are elements associated with them and that a product should be mostly consumed if it has an additional appeal.
  
          • Market size, growth projection and expectations of participation in it.
  
          The size of the market for this new promotional product through LCDs is potentially wide in that we must include the owner of the License for a determined period of time (Sports Teams, Artists, Companies and Commerce Worldwide) who, through the search for Sponsors for the development of LCDs will be able to add affiliates to their particular network where the Advertisers will also work to place their direct line of promotion through the SEMI program and finally the fan who will buy the product for three reasons:
  
          1) Have pictures, statistical data, exclusive interviews of your sports idols
          2) You can get through the advertisers that make life within the LCD, offers or promotions of their products.
          3) In order to attract even more followers to this new promotion modality, the Owners of the SEMI program and advertisers will be able to offer Award-Winning Cards, which just by opening the LCD on your computer will indicate that you have been the winner of a fantastic prize special. (What is known in Venezuela as the Prize-winning Barajita)
  
          The market growth alternatives for this product are endless, it can be extended for years, since a team or owner of the SEMI-LCD program will offer the market a Card with specific data for that edition and advertisers will promote their own products for that issue. of Digital Electronic Cards and they may change in weeks, months and even years and advertisers as well.
  
          This License can be sold worldwide, since in all the countries of the world there are Sports and Artistic idols.
  
          In the National or International market, there is nothing similar, we are making history with the beginning of the new Digital era of Cards for promotions, we will become King Midas, of this extraordinary opportunity for promotion and Business.`,
    },
  ],
  sp: [
    {
      field_name: "about_us",
      name: `Misión: Somos la primera empresa de publicidad, mercadeo que ha diseño un medio de entretenimiento para unir a empresas, fundaciones y público aficionado al acercar nuevas técnicas de interactividad y comercialización a sus clientes. Visión: Lograr que niños, jóvenes y adultos puedan tener a su disposición los adelantos tecnológicos que son necesarios para su educación y recreación. Acercando las más modernas herramientas para su desarrollo.
  
          • Introducción:
          Las agencias de publicidad desde sus inicios no tenían directores ni ejecutivos de cuentas de hecho la carrera de publicidad no requería de experiencia. Las primeras agencias eran simples comerciantes de espacios publicitarios comprando páginas en diarios y productos POP (Bolígrafos, Gorras, Etc.). En estos últimos años el negocio de la publicidad se ha vuelto muy dinámico, donde las marcas compiten por ver reflejada su imagen dentro de ese pequeño medio al que pueden llegar.
          Dado que los medios convencionales están saturados, debemos buscar la
          manera de conseguir esos patrocinios dentro de cada una de las corporaciones
          a través de nuevas ideas internas e identificar una ventaja competitiva.
          Los medios tradicionales son costosos, la tendencia es clara se debe buscar
          nuevas vías de comunicación para lograr su cometido.
          Debemos iniciar la inversión hacia nuevos medios digitales donde un cliente y
          un patrocinador consigan beneficios. Deben ganar ambas partes.
          LCD Laser Card Disc ha iniciado la transición hacia esa nueva era de
          publicidad, impulsando el desarrollo de nuevos medios alternativos de
          crecimiento económico a las corporaciones deportivas y patrocinadores
          deportivos.
          LCD es un enlace para las grandes marcas con sus productos hacia los
          fanáticos o aficionados deportivos, ellos no solo podrán tener la imagen de su
          equipo o jugador dentro de una LCD sino que además podrán tener la
          identificación del patrocinador con SLICE (nombre de los cortes comerciales
          dentro de las LCD) y podrán obtener de estos: Premios, Descuentos u
          Obsequios.
          LCD es: La publicidad dentro de la publicidad.
  
          • Propuesta Valor.
          Las Tarjetas LCD, son un producto que informa, educa, entretiene y es
          coleccionable. Estas características son únicas, son propias, son nuevas. Llega
          al mercado mundial la solución para eliminar la tala indiscriminada para la
          elaboración de: periódicos, revistas, afiches, álbum y un sin fin de productos
          más que su materia prima es los Árboles.
          Las LCD, sustituirán estos productos, son más compactos todos podrán leerlo,
          solo aquí en Venezuela, siendo este un país medio en acceso a internet existe
          más de 5.000.000 de computadores con conexión reconocidos, lo que da un
          paso a la viabilidad del producto, aunque para la utilización del mismo no sea
          necesario una conexión a INTERNET, pero si una computadora en donde este
          porcentaje se multiplicaría por 2 lo que da un total de 10.000.000 de
          Computadores. El mercado nacería y crecería con esta conciencia verde.
  
          MERCADO OBJETIVO
          • La oportunidad de negocio que identifica el producto:
          LCD (Siglas que en Ingles quiere decir: LASER CARD DISC), Barajita
          Electrónica Digital, como se dará a conocer en el habla Hispana.
          Las tarjetas electrónicas que serán emitidas para la promoción e información
          de: Personas, Grupos, Colectivos, Empresas y/o Corporaciones (Deportivas),
          podrán tener en un solo Medio todos los detalles de imágenes, datos
          estadísticos, videos y entrevistas de su elección. En donde el comprador final
          del producto podrá disfrutar de un nuevo avance en materia electrónica
          interactiva de comunicación.
          Con estos principales detalles de negocio se abren en Venezuela y el mundo la
          nueva era de la colección de imágenes, datos o videos de un jugador o
          equipos, que además brindara a todas aquellas personas que adquieran el
          producto o coleccionistas la oportunidad de poder obtener un premio por su
          devoción al participar en las innumerables formas de promoción de los
          anunciantes que tendrán acceso a este nuevo sistema de publicidad y
          mercadeo electrónico.
          LCD es una campaña publicitaria ya que lo ayuda a conseguir anunciantes
          para el patrocinio de su franquicia y lograr acumular rentabilidad o donaciones
          a través de sus clientes. SEMI - LCD es un programa que es utilizado como
          campaña de publicidad el cual fue diseñado para el poseedor de la licencia de
          uso del programa SEMI Sistema Electrónico de Mercadeo por Internet a
          usufructuar el programa por tiempo determinado, ya que lo ayudara a
          conseguir anunciantes para el patrocinio de su franquicia y lograr acumular
          rentabilidad o donaciones a través de sus clientes.
          LCD (Siglas que en Ingles quiere decir): LASER CARD DISC-Tarjeta
          Electrónica Digital), o Barajita Electrónica Digital como se dará a conocer
          en el habla español, es un producto que identifica al sistema para la promoción
          de: imágenes, datos o videos de un jugador, equipo y pudiéndose extender a
          cualquier tipo de afición ya que puede tener imágenes y sonidos. Es la nueva
          era de la colección de barajitas electrónicas.
  
          SEMI - LCD está dirigida a: Franquicias Deportivas, Grupos Empresariales,
          Personas (Artistas) o Entes Gubernamentales a nivel mundial que al adquirir
          el programa (SEMI) Sistema Electrónico de Mercadeo por Internet le generara
          ganancias al momento de aplicar el producto el cual es un servicio dual que
          aplica como campaña publicitaria.
          • Productos y/o servicios que ofrece el proyecto.
          La idea principal de SEMI – LCD, no será la elaboración, fabricación o
          digitalización de las múltiples y diferentes LCD que se deriven al momento
          que un tercero firme un contrato para usufructuar la Licencia de Uso del
          producto y/o servicio.
          La misma se traduce al momento que un consumidor (Aficionado) adquiera
          (compre) su LCD y la coloque en su computador para navegar dentro de las
          diferentes secciones del programa interno de la Tarjeta Electrónica Digital
          como lo son: fotografías, datos estadísticos, videos de jugadas, entrevistas,
          mensajes institucionales, etc., es que podrá además observar los cortes de
          propagandas o publicaciones de los miles de anunciantes y/o patrocinadores
          de un sistema privado, que tendrá un enlace único de comercialización a
          nuestra página Web: www.lcdprize.com.ve, para optar a ofertas que serán
          definidas por estos últimos.
  
          Es decir, se iniciaría la nueva era de Barajitas Electrónicas Digitales en Mini-
          CD / Pendrive-Card o cualquier otro dispositivo electromagnético o Código
          Qr de almacenamiento de datos.
  
          MERCADO POTENCIAL
          • Producto y Servicio que ofrece LCD.
          El producto principal que se ofrece a las empresas, asociaciones o
          corporaciones deportivas es la capacidad de colocar en un dispositivo
          electrónico de almacenamientos de: imágenes, sonidos, entrevista, datos
          estadísticos, videos de jugadas o momentos históricos que deben ser
          reproducidos y enaltecidos para el disfrute de una afición que nunca dejara de
          recordar.
          A través de LCD, los anunciantes obtendrán un producto que buscaran
          integrar a sus marcas en donde se apoyaran en la Barajita Electrónica Digital,
          para lograr que esos datos estadísticos, imágenes, videos, entrevistas que usted
          como franquicia, Corporación, Asociación, Grupo Empresarial posea y desea
          exponer al público. Logrando que estos sean sus aliados para el desarrollo y/o
          financiamiento.
          Para el fanático y coleccionista, este producto será una nueva forma de
          alcanzar su mayor anhelo, el cual lo lleva a esa devoción y admiración de su
          franquicia y jugador. Aunado a todo esto estará la posibilidad de obtener algún
          tipo de premiación por parte de los anunciantes y/o o patrocinadores por
          medio de lo que conocemos aquí en Venezuela como: (Barajita Premiada).
          Las Barajitas Premiadas estarán controladas electrónicamente y Digitalmente.
          Todas las LCD tendrán un código de identificación Interno que solo podrá ser
          leído por nuestro programa SEMI, que estará en internet a través de:
          www.lcdprize.com.ve
          El programa controlara la originalidad del producto es decir no pueden haber
          dos (02) LCD con el mismos código. Esto se logra al momento que un
          aficionado compre una LCD, debe activar la misma a través de Internet con un
          enlace directo a nuestra página en ese momento el aficionado queda
          identificado como propietario de una LCD original. Con este paso el producto
          es asegurado con un sistema único de originalidad electrónico. Le será
          enviado al propietario de la LCD un CEA (Certificado Electrónico de
          Autenticidad) su barajita no podrá ser clonada:
  
          El servicio que será ofrecido a los Anunciantes y Patrocinadores es: LPC
          (Link Privados de Comercialización), el programa identifica la Barajita,
          anunciando que es una original, luego el aficionado pulsa un botón o un link
          dentro de la Barajita que lo lleva directo a nuestro programa que le indicara si
          gano o no un premio.
          Cuando un aficionado compre y luego introduzca la LCD en su computador
          para navegar dentro de las diferentes secciones del programa interno de la
          Tarjeta Electrónica Digital como lo son: fotografías, datos estadísticos, videos
          de jugadas, entrevistas, mensajes institucionales es que podrá además observar
          los cortes de propagandas o publicaciones de los miles de anunciantes y/o
          patrocinadores de un sistema privado, que tendrá un enlace único de
          comercialización a nuestra página WEB: www.lcdprize.com.ve, para optar a
          ofertas que serán definidas por estos últimos.
          Es decir, se iniciará, la nueva era de Barajitas Electrónicas Digitales.
  
          COMPETENCIA
          • Público objetivo, sus características y necesidades
          El público que se encuentra enmarcado dentro de esta nueva iniciativa de
          mercadeo y publicidad se abrirá a un abanico amplio de posibilidades que
          promocionaran inicialmente las Asociaciones, Equipos, Empresas o
          Corporaciones Deportivas que, para la elaboración de las LCD, podrán
          realizar todas las Tarjetas que deseen. Donde transformaran una necesidad en
          algo tangible del público aficionado y coleccionista.
          Una característica importante es para los anunciantes es que trabajaran en esta
          nueva industria de Publicidad Electrónica Digital para poder captar clientes
          con nuevos mensajes dirigidos a un público amplísimo que gusta ir a los
          eventos Deportivos y simplemente es un consumidor frecuente a nivel
          mundial.
          El aficionado o coleccionista de un equipo y/o franquicia adquirirá un
          producto que cumple con sus necesidades porque no solo obtendrá las
          imágenes y/o videos de sus jugadores estrellas sino que además tendrá la
          opción de una barajita premiada.
          Las estadísticas nos demuestran que se suman más aficionados
          mientras existan elementos asociados a ellos y que un producto
          debe ser mayormente consumido si tiene un atractivo adicional.
  
          • Tamaño del mercado, proyección de crecimiento y expectativas de
          participación en el mismo.
          El tamaño del mercado de este nuevo producto de promoción a través de las
          LCD, es potencialmente amplio en el debemos incluir al dueño por tiempo
          determinado de la Licencia (Equipos Deportivos Artistas, Empresas y
          Comercios a Nivel Mundial) quienes a través de la búsqueda de patrocinantes
          para la elaboración de las LCD conseguirán sumar afiliados a su red particular
          donde también los Anunciantes trabajaran para colocar su línea de promoción
          directa a través del programa SEMI y por último el aficionado que comprara
          el producto por tres razones:
          1) Tener imágenes, datos estadísticos, entrevistas exclusivas de sus ídolos
          deportivos
          2) Podrá conseguir a través de los anunciantes que hacen vida dentro de la
          LCD, ofertas o promociones de sus productos.
          3) Para la captación aún mas de seguidores a esta nueva modalidad de
          promoción, los Dueños del programa SEMI y los anunciantes podrán
          ofrecer Tarjetas Premiadas, que con solo abrir las LCD en su
          computador la misma le indicara que ha sido ganador de un fantástico
          premio especial. (Lo que se conoce en Venezuela como Barajita
          Premiada)
          Las alternativas de crecimiento del mercado para este producto son infinitas la
          misma puede extenderse por años, ya que un equipo o dueño del programa
          SEMI-LCD ofrecerá al mercado una Tarjeta con datos específicos de esa
          edición y los anunciantes promocionarán sus propios productos para esa
          emisión de Tarjetas Electrónicas Digitales y las mismas podrán cambiar en
          semanas, meses y hasta años y los anunciantes también.
          Esta Licencia puede ser vendida a nivel mundial, ya que en todos los países
          del mundo existen ídolos Deportivos y Artísticos.
          En el mercado Nacional o Internacional, no existe nada parecido, estamos
          haciendo historia con el inicio de la nueva era Digital de Tarjetas para
          promociones, nos convertiremos en el Rey Midas, de esta extraordinaria
          oportunidad de promoción y Negocios.
  
          RECURSOS REQUERIDOS.
          Sr. Cesar A. Rojas Ch. Quiero indicarle que, si usted decide y acepta en tomar
          las riendas de la programación del programa SEMI y del dispositivo de
          almacenamiento digital LCD yo me encargare de la promoción y venta que
          sea necesario de las Barajitas (LCD).
          Es importante volver a reunirme con las diferentes asociaciones deportivas
          (Liga de Beisbol, Futbol y Basquetbol) que ya he conversado. Lo cual hace
          imprescindible un Demo.
          De antemano le indico que también me reuní con la agencia de publicidad
          asociada de la marca ADIDAS aquí en Venezuela. Todos ellos esperan el
          producto.
          Y para finalizar como le indicara en primer correo o mensaje.
          Ofrezco a usted el 50% de utilidad de las ventas del producto por los
          primeros 5 años y luego ofrecería el 40% por el resto de existencia del
          producto.`,
    },
  ],
};
